import { axiosApi } from 'app/api/api';
import { TableLinkData } from 'entities/table/model/tableLinkModel';
import { CreateTableParams, TableData } from 'entities/table/model/tableModel';
import { UpdateTableParams } from 'entities/table/model/updateTableHelper';

export const tablesApi = {
  fetchLinks: async (id: string, { in_trash }: { in_trash: string | null }) => {
    const res = await axiosApi.get<{ links: TableLinkData[] }>(
      `/table/get_links/${id}`,
      { params: { in_trash } }
    );

    return res.data.links;
  },

  fetchFavourits: async () => {
    const res = await axiosApi.get<{ favorite_tables: TableData[] }>(
      `/favorites/tables`
    );

    return res.data.favorite_tables;
  },
  fetchOwn: async () => {
    const res = await axiosApi.get<{ tables: TableData[] }>(`/table/`);

    return res.data.tables;
  },
  fetchTrash: async () => {
    const res = await axiosApi.get<{ files: TableData[] }>(`/trash/`);

    return res.data.files;
  },

  download: async (id: string, name: string) => {
    const res = await axiosApi.get<Blob>(`/table/download/${id}`, {
      responseType: 'blob',
    });

    const reader = new FileReader();
    reader.onload = function (e) {
      const src = e?.target?.result as string;

      if (!src) {
        return;
      }
      const link = document.createElement('a');
      link.href = src;
      link.download = `${name}.xlsx`;

      document.body.appendChild(link);
      link.click();
    };
    reader.readAsDataURL(res.data);
  },

  createInFolder: async (data: CreateTableParams) => {
    const res = await axiosApi.post<TableData>(
      `/table/create_with_links`,
      data
    );

    return res.data;
  },
  createInSection: async (data: CreateTableParams) => {
    const res = await axiosApi.post<TableData>(
      `/table/create_non_folder_with_links`,
      data
    );

    return res.data;
  },
  setFavourite: async (id: string, isFavorite: boolean) => {
    if (isFavorite) {
      await axiosApi.post(`/favorites`, {
        id,
        content_type: 'TABLE',
      });
    } else {
      await axiosApi.delete(`/favorites?id=${id}&content_type=TABLE`);
    }

    return isFavorite;
  },
  update: async (id: string, params: UpdateTableParams) => {
    const res = await axiosApi.put<TableData>(`/table/${id}`, params);

    return res.data;
  },
  fetch: async (id: string, { in_trash }: { in_trash: string | null }) => {
    const res = await axiosApi.get<TableData>(`/table/${id}`, {
      params: { in_trash },
    });

    return res.data;
  },
  delete: async (id: string) => {
    await axiosApi.delete(`/table/${id}`);

    return true;
  },
};
